import { Injectable, CommonFeatures, ServiceLocator, CommonServices } from "bwtk";
const { BaseLocalization } = CommonFeatures;

const Messages = {};
const SOURCE_WIDGET_ID = "accessibility-feedback";
@Injectable
export default class Localization extends BaseLocalization {
  get defaultMessages() {
    return Messages;
  }
  static Instance = null;
  static getLocalizedString(id: string): string {
    Localization.Instance = Localization.Instance ||
      ServiceLocator
        .instance
        .getService(CommonServices.Localization);
    const instance: any = Localization.Instance;
    return instance ? instance.getLocalizedString(SOURCE_WIDGET_ID, id) : id;
  }
}